var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 6 } },
            [
              _c("app-label", { attrs: { label: "Painel:", required: false } }),
              _c(
                "el-select",
                {
                  staticClass: "input select",
                  attrs: {
                    filterable: "filterable",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    "filter-method": _vm.filtrarPaineis,
                    placeholder: "Selecione",
                    "value-key": "id"
                  },
                  model: {
                    value: _vm.filtro.paineis,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "paineis", $$v)
                    },
                    expression: "filtro.paineis"
                  }
                },
                _vm._l(_vm.painelFiltradoList, function(painel) {
                  return _c("el-option", {
                    key: painel.id,
                    attrs: { label: painel.nome, value: painel }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Nome da demanda:", required: false }
              }),
              _c("el-input", {
                staticClass: "input",
                on: {
                  blur: function($event) {
                    return _vm.whitespace("nome")
                  }
                },
                model: {
                  value: _vm.filtro.nome,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "nome", $$v)
                  },
                  expression: "filtro.nome"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Responsável:", required: false }
              }),
              _c(
                "el-select",
                {
                  staticClass: "input select",
                  attrs: {
                    filterable: "filterable",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    "filter-method": _vm.filtrarResponsaveis,
                    disabled: !_vm.hasPainel,
                    placeholder: "Selecione",
                    "value-key": "id"
                  },
                  model: {
                    value: _vm.filtro.responsaveis,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "responsaveis", $$v)
                    },
                    expression: "filtro.responsaveis"
                  }
                },
                _vm._l(_vm.responsavelFiltradoList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.pessoa.nomeRazaoSocial, value: item }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Número da demanda:", required: false }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { onkeypress: _vm.onlyInputNumbers },
                model: {
                  value: _vm.filtro.id,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "id", $$v)
                  },
                  expression: "filtro.id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Prioridade da demanda:", required: false }
              }),
              _c(
                "el-select",
                {
                  staticClass: "input select",
                  attrs: {
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    placeholder: "Selecione",
                    "value-key": "id"
                  },
                  model: {
                    value: _vm.filtro.prioridades,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "prioridades", $$v)
                    },
                    expression: "filtro.prioridades"
                  }
                },
                _vm._l(_vm.prioridadeList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.nome, value: item }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Estado da demanda:", required: false }
              }),
              _c(
                "el-select",
                {
                  staticClass: "input select",
                  attrs: {
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    placeholder: "Selecione",
                    "value-key": "id"
                  },
                  model: {
                    value: _vm.filtro.estados,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "estados", $$v)
                    },
                    expression: "filtro.estados"
                  }
                },
                _vm._l(_vm.estadoDemandaList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.nome, value: item }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Situação da demanda:", required: false }
              }),
              _c(
                "el-select",
                {
                  staticClass: "input select",
                  attrs: {
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    placeholder: "Selecione",
                    "value-key": "codigo"
                  },
                  model: {
                    value: _vm.filtro.situacoes,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "situacoes", $$v)
                    },
                    expression: "filtro.situacoes"
                  }
                },
                _vm._l(_vm.situacaoList, function(item) {
                  return _c("el-option", {
                    key: item.codigo,
                    attrs: { label: item.nome, value: item.codigo }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Data de entrega:", required: false }
              }),
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "unlink-panels": "unlink-panels",
                  "range-separator": "até",
                  "start-placeholder": "Início",
                  "end-placeholder": "Fim",
                  format: "dd/MM/yyyy",
                  "picker-options": _vm.pickerOptions
                },
                model: {
                  value: _vm.filtro.periodoEntrega,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "periodoEntrega", $$v)
                  },
                  expression: "filtro.periodoEntrega"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78813ace", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78813ace","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/PesquisaAvancadaDemandasRelatorio.vue
// module id = null
// module chunks = 